module.exports = __webpack_public_path__ + "static/1329106643.b9f299f8.jpg";